import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import {
  AuditOutlined,
  FormOutlined,
  DollarCircleOutlined,
  TransactionOutlined,
  CalendarOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuLawsuit({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "คำฟ้อง",
      show: ROLE_ID === "1" || ROLE_ID === "3",
      items: [
        {
          icon: <AuditOutlined />,
          label: "งานฟ้อง > ตรวจสอบเอกสาร",
          path: "/lawsuit/approve-doc",
          show: true,
        },
        {
          icon: <FileDoneOutlined />,
          label: "งานฟ้อง > ฟอร์มคำฟ้องมาตรฐาน",
          path: "/lawsuit/form-lawsuit",
          show: true,
        },
        {
          icon: <FormOutlined />,
          label: "งานฟ้อง > สร้างคำฟ้อง",
          path: "/lawsuit/create-lawsuit",
          show: true,
        },
        {
          icon: <DollarCircleOutlined />,
          label: "งานฟ้อง > เบิกเงินทดรอง",
          path: "/lawsuit/withdraw-advance-payment-lawsuit",
          show: true,
        },
        {
          icon: <TransactionOutlined />,
          label: "งานฟ้อง > เคลียร์เงินทดรอง",
          path: "/lawsuit/clear-advance-payment-lawsuit",
          show: true,
        },
        {
          icon: <CalendarOutlined />,
          label: "งานฟ้อง > วันนัดศาล",
          path: "/lawsuit/appointment-court",
          show: true,
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuLawsuit;
